import confetti from 'canvas-confetti';

export const triggerEpicConfetti = (duration: number = 3000) => {
    console.log('🎉 triggerEpicConfetti called with duration:', duration);

    // Create an EPIC celebration burst of confetti
    const count = 1000;
    const defaults = {
        origin: { y: 0.7 },
        zIndex: 9999
    };

    function fire(particleRatio: number, opts: any) {
        confetti({
            ...defaults,
            ...opts,
            particleCount: Math.floor(count * particleRatio),
        });
    }

    // Fire multiple bursts for a major celebration effect
    fire(0.25, {
        spread: 26,
        startVelocity: 55,
    });

    fire(0.2, {
        spread: 60,
    });

    fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8
    });

    fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2
    });

    fire(0.1, {
        spread: 120,
        startVelocity: 45,
    });

    // Additional bursts for heavy celebration
    fire(0.15, {
        spread: 80,
        startVelocity: 35,
        decay: 0.9,
        scalar: 1.1
    });

    fire(0.2, {
        spread: 160,
        startVelocity: 30,
        decay: 0.95,
        scalar: 0.9
    });

    // EPIC CELEBRATION - Additional spectacular bursts
    fire(0.3, {
        spread: 200,
        startVelocity: 50,
        decay: 0.88,
        scalar: 1.3,
        ticks: 300
    });

    fire(0.25, {
        spread: 45,
        startVelocity: 70,
        decay: 0.9,
        scalar: 1.1,
        angle: 60
    });

    fire(0.25, {
        spread: 45,
        startVelocity: 70,
        decay: 0.9,
        scalar: 1.1,
        angle: 120
    });

    fire(0.15, {
        spread: 90,
        startVelocity: 40,
        decay: 0.92,
        scalar: 0.8,
        shapes: ['star'],
        colors: ['#FFD700', '#FFA500', '#FF6347', '#FF1493', '#9370DB']
    });
};
